import { render, staticRenderFns } from "./ContentSeoTable.vue?vue&type=template&id=0ac3d871&"
import script from "./ContentSeoTable.vue?vue&type=script&lang=js&"
export * from "./ContentSeoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../buildchain/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports